import React from 'react'
import { Wrapper, Section, SectionTitle, List, TimeSection, Label } from './index.styled'
import useTraffic from './useTraffic'
import AppointmentCard from '../../../../../components/AppointmentCard/AppointmentCard'
import { COLORS } from '../../../../../tokens'
import { shouldShowGreenBg } from '../../../../../utils/shouldShowGreenBg'
import { getVisitBadges } from '../../../LobbyScreen/getVisitBadges'

const Traffic = () => {
  const { queue } = useTraffic()

  return (
    <Wrapper>
      {/* NOW SECTION */}
      <Section>
        <SectionTitle>Now</SectionTitle>
        <List>
          {queue?.checkedIn.map((person) => (
            <AppointmentCard
              key={person.visit?.id}
              name={`${person.visit?.patient?.user?.firstname || ''} ${person.visit?.patient?.user?.lastname || ''}`.trim()}
              avatar={person.visit?.patient?.user?.profilePic || undefined}
              cardStyle={{
                cursor: 'pointer',
                marginBottom: 8,
                color: shouldShowGreenBg(person) ? COLORS.textSecondary : '#000000',
                backgroundColor: shouldShowGreenBg(person) ? COLORS.primary : '',
              }}
              nameStyle={{
                color: shouldShowGreenBg(person) ? COLORS.textSecondary : '#000000',
              }}
              badges={getVisitBadges(person, { isUpcomingOrCheckedIn: true })}
            />
          ))}
        </List>
      </Section>

      {/* UPCOMING SECTION */}
      <Section style={{ marginBottom: '12px' }}>
        <SectionTitle style={{ marginTop: '12px' }}>Upcoming</SectionTitle>
        <List style={{ marginBottom: '12px' }}>
          {queue?.upcoming.map((person, index) => (
            <TimeSection key={person.visit?.id}>
              {person.showTimeStamp && (
                <Label style={{ marginTop: index !== 0 ? '16px' : '' }}>
                  {person.visit?.appointmentTime ? person.timeStamp : '-'}
                </Label>
              )}
              <AppointmentCard
                name={`${person.visit?.patient?.user?.firstname || ''} ${person.visit?.patient?.user?.lastname || ''}`.trim()}
                avatar={person.visit?.patient?.user?.profilePic || undefined}
                cardStyle={{
                  backgroundColor: shouldShowGreenBg(person) ? COLORS.primary : '',
                  marginTop: !person.showTimeStamp ? '8px' : '',
                }}
                nameStyle={{
                  color: shouldShowGreenBg(person) ? COLORS.textSecondary : '#000000',
                }}
                badges={getVisitBadges(person, { isUpcomingOrCheckedIn: true })}
              />
            </TimeSection>
          ))}
        </List>
      </Section>
    </Wrapper>
  )
}

export default Traffic
